<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Αναφορά Επιθεωρητών</h4>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CButton
            color="primary"
            class="mb-2"
            @click="xlsCode"
            target="_blank"
          >
            Download (.xls)
          </CButton>
          <CDataTable
            :items="dateFilteredItems"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            :loading="loading"
            sorter
            @row-clicked="(item) => showCase(item.case_id)"
            clickable-rows
          >
          <template #next_visit-filter="">
            <span>Από:</span>
            <input
              type="date"
              :value="new Date(startDate).toISOString().substr(0, 10)"
              @change="setDateFilter"
              class="paddingBottomFormControl"
            /><br>
            <span>Έως:</span>
            <input
              type="date"
              :value="new Date(endDate).toISOString().substr(0, 10)"
              @change="e => setDateFilter(e, 'end')"
            />        
          </template>
          <template #name="{item}">
            <td>
              {{ item.name }}
            </td>
          </template>
          <template #next_visit="{item}">
            <td>
              {{ item.next_visit }}
            </td>
          </template>
          <template #services-filter>
            <div class="selectFilter">
              <CSelect
                :options="servicesOptions"
                :value.sync="selectedIsoOption"
              />
            </div>
          </template>
          <template #services="{item}">
            <td>
              {{ item.services }}
            </td>
          </template>
          <template #role-filter>
            <div class="selectFilter">
              <CSelect
                :options="statusOptionsRole"
                :value.sync="selectedOptionRole"
              />
            </div>
          </template>
          <template #role="{item}">
            <td>
              {{ item.inspectorsrole }}
            </td>
          </template>
          <template #client="{item}">
            <td>
              {{ item.client }}
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon"
                @click.stop="editCase( item.case_id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import js2excel from 'js2excel';

const fields = [
  {
    key: 'name', 
    label: 'Ονοματεπώνυμο', 
    sorter: true, 
    filter: true
  },
  {
    key: 'next_visit', 
    label: 'Ημερομηνία', 
    sorter: true, 
    filter: true
  },
  {
    key: 'services', 
    label: 'Πρότυπο', 
    sorter: true, 
    filter: true
  },
  {
    key: 'role', 
    label: 'Ρόλος', 
    sorter: true, 
    filter: true
  },
  {
    key: 'client', 
    label: 'Πελάτης', 
    sorter: true, 
    filter: true
  },
  {
    key: 'price',
    label: 'Ποσό',
    sorter: true,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'InspectorsReports',
  data: () => {
    return {
      items: [],
      fields,
      services_raw: '',
      clients_raw: '',
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      endDate: moment(new Date()).add(12, 'M').format('YYYY-MM-DD'),
      currentPage: 1,
      perPage: 5,
      selectedOptionRole: "Καμία επιλογή",
      statusOptionsRole: ["Καμία επιλογή"],
      selectedIsoOption: 'Καμία επιλογή',
      servicesOptions: ['Καμία επιλογή'],
      totalRows: 0,
      disabledFilter: true,
      you: null,
      message: '',
      showMessage: false,
      alertIsShown: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      loading: true,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {
    dateFilteredItems() {
      return this.items.filter(item => {
        const date = item.next_visit;

        if (this.selectedOptionRole == "Καμία επιλογή" && this.selectedIsoOption == "Καμία επιλογή") {
          return date >= this.startDate && date <= this.endDate
        } else if (this.selectedOptionRole == "Καμία επιλογή") {
          return date >= this.startDate && date <= this.endDate && item.services == this.selectedIsoOption;
        } else if (this.selectedIsoOption == "Καμία επιλογή") {
          return date >= this.startDate && date <= this.endDate && item.inspectorsrole == this.selectedOptionRole;
        } else {
          return date >= this.startDate && date <= this.endDate && item.inspectorsrole == this.selectedOptionRole && item.services == this.selectedIsoOption;
        }
      })
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    xlsCode () {
      this.tempArr = this.dateFilteredItems.map((item) => {
        return {
          Ονοματεπώνυμο: item.name,
          Ημερομηνία: item.next_visit,
          Πρότυπο: item.services,
          Ρόλος: item.inspectorsrole,
          Πελάτης: item.client,
          Ποσό: item.price
        }
      });

      try {
        js2excel.json2excel({
            data: this.tempArr,
            name: 'inspectors-data',
            formateDate: 'dd/mm/yyyy'
        });
      } catch (e) {
          console.error('export error: ', e);
      }
    },
    setDateFilter (e, end) {
      if (end) {
        this.endDate = moment(new Date(e.target.value)).format('YYYY-MM-DD')
      } else {
        this.startDate = moment(new Date(e.target.value)).format('YYYY-MM-DD')
      }
    },
    getServiceName(id) {
      var temp = this.services_raw.find((item) => { if (item.id == id) { return item; } });

      return temp.name;
    },
    getClientsName(id) {
      var temp = this.clients_raw.find((item) => { if (item.id == id) { return item; } });

      return temp.company;
    },
    caseLink (id) {
      return `cases/${id.toString()}`
    },
    editLink (id) {
      return `cases/${id.toString()}/edit`
    },
    showCase ( id ) {
      const caseLink = this.caseLink( id );
      this.$router.push({path: caseLink});
    },
    editCase ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getInspectorReports (){
      let self = this;

      axios.get('/api/services?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.services_raw = response.data.services;
        self.services = response.data.services.map((item) => {
          return item;
        });
        self.servicesOptions = ['Καμία επιλογή', ...new Set(self.services.map(item => item.name))];
        self.selectedIsoOption = self.servicesOptions[0];

        axios.get('/api/clients?token=' + localStorage.getItem("api_token"))
        .then(function (response) {
          self.clients_raw = response.data.clients;

          axios.get('/api/inspectors/get_cases_inspectors?token=' + localStorage.getItem("api_token"))
          .then(function (response) {
            let temp = response.data.inspectors_roles.map((item) => {
              return item.role;
            });
            self.statusOptionsRole = self.statusOptionsRole.concat(temp);
            self.items = response.data.cases_inspectors.map((item) => {
                item.name = item.inspectors.name;
                item.services = self.getServiceName(item.cases.service_id);
                item.client = self.getClientsName(item.cases.client_id);
                item.next_visit = item.cases.next_visit[0];
                item.inspectorsrole = response.data.inspectors_roles.find((item2) => item2.id == item.role_id).role;
                item.price = item.price + '€';
                return item;
            });
            self.you = response.data.you;
            self.loading = false;
          }).catch(function (error) {
            console.log(error);
            self.loading = false;
            self.$router.push({ path: '/login' });
          });
        }).catch(function (error) {
          console.log(error);
          self.$router.push({ path: '/login' });
        });
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
  },
  mounted: function(){
    this.getInspectorReports();
  }
}
</script>